import * as React from 'react';
import {useDispatch} from 'react-redux';

import {colors} from 'shells/colors/colors';
import {WarningIcon} from 'shells/icon/svg/warning-icon';

import {openAllLimitsModal} from './limits-actions';

import styles from './title-bar-limits.module.css';

export function LimitsWarning() {
    const dispatch = useDispatch();

    const openModal = () => {
        dispatch(openAllLimitsModal({}));
    };

    return (
        <div
            onClick={openModal}
            data-tip='Your usage is above some plans’ limits'
            className={styles['title-bar-warning']}
        >
            {/* @ts-expect-error */}
            <WarningIcon size={15} color={colors.yellow} />
        </div>
    );
}
